export var current_account = window.localStorage.getItem('current_account')
  ? JSON.parse(window.localStorage.getItem('current_account'))
  : {};

export function allow_manager_roles(roles = []) {
  const currentRole = current_account.manager_role;
  return roles.includes(currentRole);
}
